import { computed, ref, ComputedRef, DeepReadonly, Ref } from 'vue'
const canvas = document.createElement('canvas')
export const defaultTrackFontSize = '12px'

/**
 * This composable takes in a reactive string and a font then returns one that is either the full input string or
 * a truncated string with ellipsis in the middle if it is longer than 245px wide
 * 
 * @param str Input string (reactive)
 * @param fontSize The font size used to calculate the text width (reactive)
 * @returns A reactive string that is either truncated or the whole string
 */
export default function useWidthLimitedFileName (str: DeepReadonly<Ref<string>>, fontSize: DeepReadonly<Ref<string>> = ref(defaultTrackFontSize)): ComputedRef<string> {
  const getTextWidth = (text: string, font: string): number => {
    const context = canvas.getContext('2d')
    if (!context) {
      console.error('Failed to create canvas')
      throw new Error()
    }

    context.font = font
    const metrics = context.measureText(text)
    return metrics.width
  }

  return computed(() => {
    const font = `${fontSize.value} HelveticaNeueW01-65Medi`
    let fileName = str.value
    let isShortened = false

    while (getTextWidth(fileName, font) > 245) {
      fileName = fileName.substring(0, ((fileName.length-1) / 2) - 1) + fileName.substring(((fileName.length-1) / 2) + 2, fileName.length) 
      isShortened = true
    }
    if (isShortened) {
      fileName = fileName.substring(0, (fileName.length / 2)) + '...' + fileName.substring((fileName.length / 2), fileName.length)
    }
    return fileName
  })
}